module.exports = __webpack_public_path__ + "02_very_short_black.ccd25836.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/02_very_short_black.png
// module id = S7b5
// module chunks = 0